let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gLVYd")).then(() => parcelRequire('4EbGZ'));